import { AxiosInstance } from 'axios';
import { getExportConfig, handleFileExport } from '../../../../../../helpers/fileExport';
import { FINANCIAL_ACCOUNT_REPORT } from '../endpoint';
import { FinancialAccountReportRequestModel } from '../models/FinancialAccountReportRequestModel';

export const exportPDF =
  (axios: AxiosInstance) =>
  async (params?: FinancialAccountReportRequestModel): Promise<void> => {
    return await axios
      .get(`${FINANCIAL_ACCOUNT_REPORT}`, {
        params: { ...params },
        ...getExportConfig(params),
      })
      .then(response => {
        handleFileExport(response, {
          file_type: params?.file_type,
          filename: 'financial-account-report',
        });
      });
  };
